import React, { useState } from "react";
import axios from "axios";
import { FaPaperPlane } from "react-icons/fa";
import "./Chatbot.css";
import App from "./App";
//import { JSDOM } from 'jsdom';
//import DOMPurify from 'dompurify';

import { useCookie } from "./useCookie";
//import { withCookies } from 'react-cookie';
//import {useCookies } from "react-cookie";
//import Session from './Session.js';

/*
const [cookies, setCookie] = useCookies(["session"]);


    function getCookie(name) {
        try {
            const threadid="user_id"+String(Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000);
            const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
            const result= match ? decodeURIComponent(match[2]) : null;
            if (result === undefined || result === null){
          
                setCookie(name, threadid, {
                    path: "/",           // Cookie available across the site
                    maxAge: 3600,        // 1 hour in seconds
                    secure: true,        // Only sent over HTTPS
                    sameSite: "strict"   // CSRF protection
                });
                return threadid;
            }else
                return result;
          } catch (error) {
            console.error("Error setting cookie:", error);
             
            return "user_id"+String(Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000);
          }
    };
*/
const Chatbot = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [user, setUser, removeUser] = useCookie("user");

  const handleSend = async () => {
    if (input.trim() === "") return;

    const newMessage = { text: input, sender: "user" };
    setMessages([...messages, newMessage]);
    setInput("");
    setLoading(true);

    //App.cookies.set("session", "asdfsdf", { path: "/", maxAge: 3600 });
    const payload = { message: input, thread: user };
    //const payload = JSON.stringify({message: input });

    //headers={'Content-Type': 'application/json'};

    try {
      //http://192.168.1.109:8002/chat
      //,{headers: {'Content-Type': 'application/json'}, timeout: 5000}
      const response = await axios.post(
        "https://rest.fistsoffuryboxing.org/chat",
        payload,
        { headers: { "Content-Type": "application/json" }, timeout: 50000 },
      );
      console.log("Status:", response.status);
      console.log("Response Data:", response.data);
      //const window = new JSDOM('').window;
      //const purify = DOMPurify(window);
      //const clean = purify.sanitize(response.data);

      const aiMessage = { text: response.data, sender: "ai" };

      setMessages([...messages, newMessage, aiMessage]);
    } catch (error) {
      if (error.response) {
        console.error(
          "Server responded with error:",
          error.response.status,
          error.response.data,
        );
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up request:", error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setInput(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      console.log("Hit Enter");
      handleSend();
    }
  };

  return (
    <div className="chatbot-container">
      <div className="chat-header">
        <img
          src="logo_gloves.png"
          alt="Fists of Fury Boxing"
          className="chat-logo"
        />
        <font face="aria-live" size="5">
          <b>Fists of Fury AI Chat</b>
        </font>
        <div className="breadcrumb">
          <a href="https://fistsoffuryboxing.org" target="_blank">
            Home
          </a>
        </div>
      </div>

      <div className="chatbox">
        <div class="message-container ai">
          <img src="rocky.jpg" alt="avatar" class="avatar" />
          <div class="message ai">
            Yo Champ I am Rocky, I am here to help you Register With
            fistsoffuryboxing! Ask Me any thing Capeesh!
          </div>
        </div>

        {messages.map((message, index) => (
          <div key={index} className={`message-container ${message.sender}`}>
            <img
              src={message.sender === "user" ? "logo_gloves.png" : "rocky.jpg"}
              alt={`${message.sender} avatar`}
              className="avatar"
            />
            <div className={`message ${message.sender}`}>
              {message.sender === "user" ? (
                message.text
              ) : (
                <div dangerouslySetInnerHTML={{ __html: message.text }} />
              )}
            </div>
          </div>
        ))}
        {loading && (
          <div className="message-container ai">
            <img src="rocky.jpg" alt="AI avatar" className="avatar" />
            <div className="message ai">...</div>
          </div>
        )}
      </div>
      <div className="input-container">
        <input
          type="text"
          value={input}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          placeholder="Type your message..."
        />
        <button onClick={handleSend}>
          <FaPaperPlane />
        </button>
      </div>
    </div>
  );
};

export default Chatbot;
